import { ReducersMapObject } from '@reduxjs/toolkit';
import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

// import administration from 'pages/thermography/modules/administration/administration.reducer';
// import userManagement from 'pages/thermography/modules/administration/user-management/user-management.reducer';
import register from 'pages/thermography/modules/account/register/register.reducer';
import activate from 'pages/thermography/modules/account/activate/activate.reducer';
import password from 'pages/thermography/modules/account/password/password.reducer';
// import settings from 'pages/thermography/modules/account/settings/settings.reducer';
import passwordReset from 'pages/thermography/modules/account/password-reset/password-reset.reducer';
// import entitiesReducers from 'pages/thermography/entities/reducers';
import applicationProfile from './application-profile';
import authentication from './authentication';
import locale from './locale';
import inspectionRouteReducer from '../../InspectionRoute/features/inspectionRouteSlice';
import inspectionRecordReducer from '../../InspectionRecord/features/inspectionRecordSlice';
import dataImportWizardReducer from "../../../thermography/DataImportWizard/dataImportWizardSlice";
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const rootReducer: ReducersMapObject = {
  authentication,
  locale,
  applicationProfile,
  // administration,
  // userManagement,
  register,
  activate,
  passwordReset,
  password,
  // settings,
  loadingBar,
  inspectionRoute: inspectionRouteReducer,
  inspectionRecord: inspectionRecordReducer,
  dataImportWizard: dataImportWizardReducer
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  // ...entitiesReducers,
};

export default rootReducer;
